import { MyLink, SkeletonLoading } from '@app/shared';
import { useAppSelector } from '@redux/hooks';
import { quantityLimitation } from '@shared/helpers';
import { ElementIdTab } from '@entities/Product';
import { AvailableType } from '@entities/Delivery';
import { AvailableStringCatalogProductRow, AvailableStringProductRow } from '@entities/Delivery/module/types/deliveryTypes';
import { RowAvailabilityTypeProps, WrapperRowAvailabilityTypeProps } from './TypeProps';
import { useGetProductAvailabilityInStoresQuery } from '../../module/services/getProductAvailabilityInTheStoresData';
import { showAvailabilityLater } from '../../module/helpers/showAvailabilityLater';
import IconSuccess from './icons/success.svg';
import classNames from 'classnames';

import styles from './RowAvailability.module.scss';

export const RowAvailability = ({ className, productRN, part, productUrl = '', isShort }: WrapperRowAvailabilityTypeProps) => {
  const { REGION: regionId } = useAppSelector(state => state.header.data.region);
  const { data, isLoading, isError } = useGetProductAvailabilityInStoresQuery({ productRN, regionId: +regionId, part });
  if (!data && isLoading) {
    return (
      <div className={classNames(styles.WrapperRowAvailability, className)}>
        <SkeletonLoading width={'70%'} height={'21px'} />
      </div>
    );
  } else if (isError || !data) {
    return null;
  } else {
    const { availabilityLater, availabilityNow } = data;
    return (
      <>
        {isShort ? (
          <RowAvailability.RowShort
            availabilityNow={availabilityNow}
            availabilityLater={availabilityLater}
            className={className}
            productUrl={productUrl}
          />
        ) : (
          <RowAvailability.Row
            availabilityNow={availabilityNow}
            availabilityLater={availabilityLater}
            className={className}
            productUrl={productUrl}
          />
        )}
      </>
    );
  }
};

const handlerGenerateHref = (productUrl: string, type: AvailableType, isCatalog: boolean, hasNonTodayDeliveryStores: boolean): string => {
  if (isCatalog) {
    return `${productUrl}#${hasNonTodayDeliveryStores ? ElementIdTab.TabAvailabilityNoFast : ElementIdTab.TabAvailabilityRecordOrder}`;
  }

  return `${productUrl}#${
    type === AvailableType.OnOrderFromFiveDays ? ElementIdTab.TabAvailabilityRecordOrder : ElementIdTab.TabAvailabilityNoFast
  }`;
};

RowAvailability.Row = function Row({
  availabilityLater,
  availabilityNow,
  className,
  productUrl,
  isCatalog,
  hasNonTodayDeliveryStores,
}: RowAvailabilityTypeProps) {
  const AvailableString = isCatalog ? AvailableStringCatalogProductRow : AvailableStringProductRow;

  return (
    <div className={classNames(styles.WrapperRowAvailability, className)}>
      {!!availabilityNow?.quantity && (
        <MyLink href={`${productUrl}#${ElementIdTab.TabAvailabilityFast}`} className={styles.inStock}>
          {`${quantityLimitation(availabilityNow.quantity)} шт. ${AvailableString[availabilityNow.type]}`}
        </MyLink>
      )}
      {showAvailabilityLater(availabilityLater?.quantity, availabilityNow?.quantity) && (
        <MyLink href={handlerGenerateHref(productUrl, availabilityLater.type, isCatalog, hasNonTodayDeliveryStores)} className={styles.onOrder}>
          {`${quantityLimitation(availabilityLater.quantity)} шт. ${AvailableString[availabilityLater.type]}`}
        </MyLink>
      )}
      {!availabilityNow?.quantity && !availabilityLater?.quantity && (
        <div className={styles.onOrder}>{AvailableString[AvailableType.NoInfo]}</div>
      )}
    </div>
  );
};

RowAvailability.RowShort = function RowShort({ availabilityNow, className }: RowAvailabilityTypeProps) {
  if (!availabilityNow?.quantity) {
    return null;
  }
  return (
    <div className={classNames(styles.WrapperRowAvailabilityShort, className)}>
      <IconSuccess /> в наличии
    </div>
  );
};
